import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiInstance } from './axiosInstance';
import { store } from 'store';
import { hideLoading, showLoading } from 'reducer/rootReducer';
class ApiService {
    public async get<TRequest, TResponse>(
        endpoint: string,
        params?: TRequest,
        config?: AxiosRequestConfig,
        isShowLoading = false,
    ): Promise<ApiResponse<TResponse>> {
        isShowLoading && store.dispatch(showLoading());

        try {
            const response = await apiInstance.get<TResponse>(endpoint, {
                params,
                ...config,
            });

            return {
                success: true,
                data: response.data,
                message: (response.data as ResponseBase<TResponse>)?.message || '',
            };
        } catch (error) {
            return this.handleError(error);
        } finally {
            isShowLoading && store.dispatch(hideLoading());
        }
    }

    public async post<TRequest, TResponse>(
        endpoint: string,
        data?: TRequest,
        config?: AxiosRequestConfig,
        isShowLoading = false,
    ): Promise<ApiResponse<TResponse>> {
        isShowLoading && store.dispatch(showLoading());
        try {
            const response = await apiInstance.post<TResponse>(endpoint, data, config);

            return {
                success: true,
                data: response.data,
                message: (response.data as ResponseBase<TResponse>)?.message || '',
            };
        } catch (error) {
            return this.handleError(error);
        } finally {
            isShowLoading && store.dispatch(hideLoading());
        }
    }

    public async put<TRequest, TResponse>(
        endpoint: string,
        data?: TRequest,
        config?: AxiosRequestConfig,
        isShowLoading = false,
    ): Promise<ApiResponse<TResponse>> {
        isShowLoading && store.dispatch(showLoading());

        try {
            const response = await apiInstance.put<TResponse>(endpoint, data, config);

            return {
                success: true,
                data: response.data,
                message: (response.data as ResponseBase<TResponse>)?.message || '',
            };
        } catch (error) {
            return this.handleError(error);
        } finally {
            isShowLoading && store.dispatch(hideLoading());
        }
    }

    public async patch<TRequest, TResponse>(
        endpoint: string,
        data?: TRequest,
        config?: AxiosRequestConfig,
        isShowLoading = false,
    ): Promise<ApiResponse<TResponse>> {
        isShowLoading && store.dispatch(showLoading());
        try {
            const response = await apiInstance.patch<TResponse>(endpoint, data, config);

            return {
                success: true,
                data: response.data,
                message: (response.data as ResponseBase<TResponse>)?.message || '',
            };
        } catch (error) {
            return this.handleError(error);
        } finally {
            isShowLoading && store.dispatch(hideLoading());
        }
    }

    public async delete<TRequest, TResponse>(
        endpoint: string,
        params?: TRequest,
        data?: TRequest,
        config?: AxiosRequestConfig,
        isShowLoading = false,
    ): Promise<ApiResponse<TResponse>> {
        isShowLoading && store.dispatch(showLoading());

        try {
            const response = await apiInstance.delete<TResponse>(endpoint, {
                params,
                data,
                ...config,
            });

            return {
                success: true,
                data: response.data,
                message: (response.data as ResponseBase<TResponse>)?.message || '',
            };
        } catch (error) {
            return this.handleError(error);
        } finally {
            isShowLoading && store.dispatch(hideLoading());
        }
    }

    private handleError(error: unknown): ApiResponse<never> {
        let errorMessage = 'Unknown Error';

        if (error instanceof AxiosError) {
            const responseData = error.response?.data;

            errorMessage = responseData?.error || responseData?.message || error.message;
        } else if (error instanceof Error) {
            errorMessage = error.message;
        } else if (typeof error === 'string') {
            errorMessage = error;
        } else {
            errorMessage = `${errorMessage}: ${JSON.stringify(error)}`;
        }

        return {
            success: false,
            error: errorMessage,
        };
    }
}

export const apiService = new ApiService();
